/* eslint-disable import/prefer-default-export */
import CoursesAndTrainingRequests from '../../server/coursesAndTraining';
import { addLoading, removeLoading } from './loading';

export const getListCoursesAndTraining = (limit, skip, search, orderBy, field) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CoursesAndTrainingRequests.getListCoursesAndTraining(limit, skip, search, orderBy, field);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvCoursesAndTraining = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CoursesAndTrainingRequests.getCsvCoursesAndTraining();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCoursesAndTraining = coursesAndTrainingParameter => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CoursesAndTrainingRequests.uploadCoursesAndTraining(coursesAndTrainingParameter);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCsvCoursesAndTraining = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CoursesAndTrainingRequests.uploadCsvCoursesAndTraining(file);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteCoursesAndTraining = coursesAndTrainingId => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await CoursesAndTrainingRequests.deleteCoursesAndTraining(coursesAndTrainingId);
  } finally {
    dispatch(removeLoading());
  }
};
